<template lang="pug">
  v-tabs(
    :background-color="backgroundColor"
    :center-active="centerActive"
    :dark="dark"
    :slider-color="sliderColor"
  )
    v-tab(
      v-for="(item, index) in items"
      :key="index"
      dark
      link
      exact
      :to="item.path"
    )
      slot(
        name="tab.item"
        v-bind:item="item"
      )
        span {{ item.label }}
</template>
<script>
  export default {
    name: 'BaseTabs.vue',
    props: {
      backgroundColor: {
        type: String,
        default: '',
      },
      sliderColor: {
        type: String,
        default: '',
      },
      centerActive: {
        type: Boolean,
        default: true,
      },
      dark: {
        type: Boolean,
        default: false,
      },
      items: {
        type: Array,
        default: () => [],
      },
    },
  }
</script>
